/*
 * @Author: 黄贺林
 * @Date: 2024-06-11 13:54:53
 * @LastEditTime: 2025-02-20 13:50:22
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { i18n } from './lang'
import router from './router'
// import axiosLog from './utils/axiosLog.js'
import md5 from 'js-md5';
import resetMessage from '@/utils/resetMessage'
import '@/assets/reset.css'
// import Casdoor from 'casdoor-vue-sdk'
import store from './store'
import adapter from 'webrtc-adapter'
import common from '@/utils/common.js'
import global from '@/utils/global.js'
import { createSSDPClient } from '@/utils/ssdp.js'
import { uuid } from "vue-uuid";
import '@/assets/fonts/font.css'
//  引入浅色与暗色模式
import '@/assets/global.css'
import '@/assets/elInit.css'
import { configWrite, common_notify } from '@/api/slicer/printer'
import { sliceJumpWorkbench } from '@/utils/sliceJumpWorkbench'
//  神策sdk注入
import '@/utils/sensors.js'

/**
 * @description: Casdoor目前由切片软件调起web端暂时不用处理
 */
// const config = {
//   serverUrl: process.env.VUE_APP_CASDOOR_URL,
//   clientId: process.env.VUE_APP_CASDOOR_ID,
//   organizationName: "anycubic",
//   appName: process.env.VUE_APP_CASDOOR_APP_NAME,
//   redirectPath: process.env.VUE_APP_BASE_URL,
// };

// Vue.use(Casdoor, config)
Vue.use(adapter)

common.getSetting()

Vue.use(ElementUI, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
});

store.commit("SET_ISONLINE", true);

Vue.config.productionTip = false
Vue.config.productionTip = false;
// Vue.prototype.$httpLog = axiosLog;
Vue.prototype.$global = global;
Vue.prototype.$md5 = md5;
Vue.prototype.$message = resetMessage;
Vue.prototype.$ssdpclient = createSSDPClient();
Vue.prototype.$common = common;
Vue.prototype.$uuid = uuid;

// 用于复现bug
// let LanList = JSON.parse(JSON.stringify(store.getters.GET_LAN_PRINTER_LIST));
// LanList[1] = { ...LanList[1],ip: '192.168.23.23' };
// LanList[0] = { ...LanList[0],ip: '192.168.23.231' };

// store.commit("SET_LAN_PRINTER_LIST", LanList);


new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.notify = (res) => {
  console.log('notify========>', res);
}
window.sliceJumpWorkbench = sliceJumpWorkbench

setInterval(() => {
  const fild = navigator.userAgent.match(RegExp('dark', 'i'))
  if (fild) {
    store.commit('SET_IS_DARK', true)
  } else {
    store.commit('SET_IS_DARK', false)
  }
}, 1000)
//  删除用户数据
store.commit('SET_DOWNLOAD_FILE_LIST', []);
configWrite('TransferDownloadStatus', 0);
configWrite('TransferUploadStatus', 0);
common_notify();
store.dispatch('GET_USER_DOWNLOAD_LIST')